import { createContext, useContext } from "react";

// Context for the currently selected cash box. Extracted from Layout.js to
// avoid a circular import between Layout and ExpensesDailyAlert.
export const BoxContext = createContext();

export const useBox = () => {
  const context = useContext(BoxContext);
  if (!context) {
    throw new Error('useBox must be used within BoxProvider');
  }
  return context;
};
